import styled from 'styled-components';

//helpers
import {borderRadius, cardShadowCss} from 'styles/vars';

//components
import Link from 'components/Link';
import {HeadingDesktop as $HeadingDesktop, HeadingMobile as $HeadingMobile} from 'components/Heading';

export const GuideCardStatic = styled.div`
  ${p => cardShadowCss(p.device === 'desktop' && p.isLink)};
  background: #fff;
  border-radius: ${p => borderRadius[p.device]}px;
  overflow: hidden;
  display: block;
  height: 100%;
`;

export const GuideCardLink = GuideCardStatic.withComponent(Link);

export const HeadingDesktop = styled($HeadingDesktop).attrs({
  maxLines: 3,
  size: 'xsmall'
})`
  && {
    margin: 0.8rem 1rem;
  }
`;

export const HeadingMobile = HeadingDesktop.withComponent($HeadingMobile);
